var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49 52",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1770_4220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0817 23.5851L23.1531 16.6565L24.9796 14.8301L35.0263 24.8768L24.9796 34.9235L23.1531 33.097L30.0817 26.1685H14.3594V23.5851H30.0817Z",
    fill: "url(#paint0_linear_1770_4220)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_1770_4220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9266 20.4039C42.927 15.5807 40.2081 11.2854 36.2764 8.31826C32.3448 5.35114 27.4685 3.91456 22.5561 4.27619C17.6438 4.63782 13.0304 6.773 9.57559 10.2839C6.1208 13.7948 4.06021 18.4419 3.77774 23.3595C3.49528 28.277 5.01022 33.1296 8.04029 37.0129C11.0704 40.8963 15.4089 43.5457 20.2475 44.4674C25.0862 45.3892 30.0949 44.5204 34.3405 42.0229C38.586 39.5255 41.7789 35.5698 43.3241 30.8928L39.4277 29.6054C38.1948 33.3371 35.6473 36.4933 32.2598 38.4859C28.8724 40.4786 24.8761 41.1717 21.0154 40.4363C17.1548 39.7009 13.6932 37.587 11.2756 34.4886C8.85795 31.3901 7.64922 27.5184 7.87458 23.5948C8.09995 19.6712 9.74405 15.9634 12.5005 13.1621C15.257 10.3609 18.9379 8.65724 22.8574 8.36871C26.7768 8.08017 30.6675 9.22638 33.8045 11.5938C36.9415 13.9612 39.1109 17.3883 39.9084 21.2366L43.9266 20.4039Z",
    fill: "#05BEB3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_1770_4220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9266 20.4039C42.9284 15.5873 40.2155 11.2969 36.2921 8.33009C32.3687 5.36324 27.5015 3.92169 22.5952 4.27334C17.6889 4.625 13.0771 6.74594 9.61694 10.242C6.15673 13.7381 4.08345 18.3715 3.7824 23.2811C3.48134 28.1908 4.97299 33.0428 7.98013 36.9355C10.9873 40.8281 15.3054 43.4966 20.132 44.4451C24.9585 45.3935 29.9653 44.5574 34.2219 42.0922C38.4784 39.6269 41.6951 35.7001 43.2743 31.0416L40.8401 30.2165C39.4609 34.2852 36.6514 37.7149 32.9337 39.8681C29.2161 42.0212 24.8431 42.7515 20.6276 41.9231C16.412 41.0947 12.6406 38.764 10.0141 35.3642C7.38766 31.9643 6.08484 27.7266 6.34779 23.4385C6.61073 19.1503 8.42154 15.1035 11.4437 12.05C14.4659 8.99655 18.4938 7.14411 22.779 6.83698C27.0642 6.52984 31.3151 7.7889 34.7419 10.3802C38.1686 12.9714 40.538 16.7186 41.4099 20.9254L43.9266 20.4039Z",
    fill: "url(#paint1_radial_1770_4220)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1770_4220",
    x: 1.64128,
    y: 2.11198,
    width: 46.1022,
    height: 45.5299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.35905,
    dy: 6.35905
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.17952
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1770_4220"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6.35905,
    dy: -6.35905
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.17952
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1770_4220",
    result: "effect2_dropShadow_1770_4220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1770_4220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_1770_4220",
    x: 0.495768,
    y: 4.2207,
    width: 46.6784,
    height: 47.1022,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.24837
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.62419
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1770_4220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1770_4220",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.62419,
    dy: 3.24837
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.62419
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1770_4220"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_1770_4220",
    x: 0.495768,
    y: 4.2207,
    width: 46.6784,
    height: 47.1022,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.24837
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.62419
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1770_4220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1770_4220",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.62419,
    dy: 3.24837
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.812093
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1770_4220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1770_4220",
    x1: 24.6928,
    y1: 14.8301,
    x2: 24.6928,
    y2: 34.9235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1973EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04A299"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1770_4220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6492 16.7261) rotate(43.6172) scale(36.0428)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1363FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightNew);
export default __webpack_public_path__ + "static/media/arrowRightNew.0bcdcaad283b9375717173929bb4533a.svg";
export { ForwardRef as ReactComponent };